export const GET_CURRENT_USER = 'GET_CURRENT_USER';
export const LOGOUT = 'LOGOUT';
export const SET_INITIAL_URL = 'SET_INITIAL_URL';